import React, { useRef, useState } from 'react';
import { string, bool, object } from 'prop-types';
import Paper from '@material-ui/core/Paper';

import { generateReportUrl } from '../../util/reports';

const OutputFrame = ({
  reportId,
  durationKey,
  isReportReady,
  nightModeEnabled,
  isPremium,
  options,
  isStoredReport,
  editable
}) => {
  const iframeRef = useRef(null);
  const [frameHeight, setFrameHeight] = useState('calc(100vh - 8px)');

  const handleLoad = () => {
    // The page stays at the top, with the site header in view, and the report fills the
    // window from where it starts to the bottom edge (Full Screen gives it the whole screen)
    const GAP_BELOW_REPORT = 16;
    if (iframeRef.current) {
      window.scrollTo(0, 0);
      const top = iframeRef.current.getBoundingClientRect().top;
      setFrameHeight(`calc(100vh - ${Math.round(top) + GAP_BELOW_REPORT}px)`);
    }

    // Stored reports already have the correct toggle states baked in at store time;
    // applying the viewer's current saved options would overwrite them (and the viewer
    // may not even be the same user who stored the report).
    if (isStoredReport) return;
    if (!iframeRef.current) return;
    try {
      const win = iframeRef.current.contentWindow;
      win.postMessage({ type: 'applyOrientation', vertical: !!(options && options.hrz) }, '*');
      win.postMessage({ type: 'applyInspector', enabled: !!(options && options.sli) }, '*');
      if (isPremium)
        win.postMessage({ type: 'applyWordWrap', enabled: !!(options && options.uww) }, '*');
      // Merging in the report (plain text only)
      if (editable) win.postMessage({ type: 'enableEditing' }, '*');
    } catch (e) {
      // iframe may not be ready yet; ignore
    }
  };

  return (
    <Paper
      style={{
        padding: 4,
        display: reportId && isReportReady ? 'block' : 'none'
      }}
    >
      {isReportReady && (
        <iframe
          ref={iframeRef}
          id="diff-report-frame"
          title="DiffNow Output Frame"
          style={{
            display: 'block',
            width: '100%',
            height: frameHeight,
            minHeight: 400,
            border: 'none'
          }}
          src={
            reportId && `${generateReportUrl(reportId, durationKey)}&ww=${isPremium ? '1' : '0'}`
          }
          onLoad={handleLoad}
        />
      )}
    </Paper>
  );
};

OutputFrame.propTypes = {
  reportId: string,
  durationKey: string,
  isReportReady: bool,
  nightModeEnabled: bool,
  isPremium: bool,
  options: object,
  isStoredReport: bool,
  editable: bool
};

export default OutputFrame;
